<div class="toastContainer"></div>
<div class="bigger-container">
  <div class="left-section">
    <p class="filter-title">Filtra</p>
    <form class="filters" [formGroup]="form">
      <div>
        <label for="status">Cerca per ID</label>
        <input
          id="filters-doc_ref"
          type="text"
          formControlName="doc_ref"
          placeholder="Cerca per ID"
        />
      </div>
      <div>
        <label for="status">Cerca per nome e cognome</label>
        <input
          id="filters-name"
          type="text"
          formControlName="name"
          placeholder="Cerca per nome/cognome"
        />
      </div>
      <div>
        <label for="status">Cerca per email</label>
        <input
          id="filters-email"
          type="text"
          formControlName="email"
          placeholder="Cerca per email"
        />
      </div>

      <hr
        class="w-100 my-3 text-white border-2 rounded border-light opacity-100"
      />
      <div class="elements-limit-container w-100">
        <label for="specialty" class="w-100">Specializzazioni:</label>
        <div class="d-flex justify-content-start text-xs">
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="life_coaching"
              formControlName="life_coaching"
            />
            <label class="pointer" for="life_coaching">Life coaching</label>
          </div>
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="coaching_aziendale"
              formControlName="coaching_aziendale"
            />
            <label class="pointer" for="coaching_aziendale"
              >Coaching aziendale</label
            >
          </div>
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="executive_coaching"
              formControlName="executive_coaching"
            />
            <label class="pointer" for="executive_coaching"
              >Executive coaching</label
            >
          </div>
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="coaching_di_leadership"
              formControlName="coaching_di_leadership"
            />
            <label class="pointer" for="coaching_di_leadership"
              >Coaching di leadership</label
            >
          </div>
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="leadership_coaching"
              formControlName="leadership_coaching"
            />
            <label class="pointer" for="leadership_coaching"
              >Leadership coaching</label
            >
          </div>
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="mindfulness_coaching"
              formControlName="mindfulness_coaching"
            />
            <label class="pointer" for="mindfulness_coaching"
              >Mindfulness coaching</label
            >
          </div>
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="relationship_coaching"
              formControlName="relationship_coaching"
            />
            <label class="pointer" for="relationship_coaching"
              >Coaching relzionale</label
            >
          </div>
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="spiritual_coaching"
              formControlName="spiritual_coaching"
            />
            <label class="pointer" for="spiritual_coaching"
              >Coaching spirituale</label
            >
          </div>
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="coaching_for_personal_growth"
              formControlName="coaching_for_personal_growth"
            />
            <label class="pointer" for="coaching_for_personal_growth"
              >Coaching per la crescita personale</label
            >
          </div>
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="corporate_wellness_coaching"
              formControlName="corporate_wellness_coaching"
            />
            <label class="pointer" for="corporate_wellness_coaching"
              >Coaching per il benessere aziendale</label
            >
          </div>
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="mental_coaching_per_sportivi_e_performance"
              formControlName="mental_coaching_per_sportivi_e_performance"
            />
            <label
              class="pointer"
              for="mental_coaching_per_sportivi_e_performance"
              >Mental coaching per sportivi</label
            >
          </div>
        </div>
      </div>
      <button
        class="reset-button"
        data-cy="reset-button"
        (click)="resetFilters()"
      >
        RESET
      </button>
    </form>
  </div>
  <div class="right-section">
    <div class="smaller-container">
      <p class="smaller-text">Allenatori Family Happy</p>
      <div class="smaller-bar"></div>
    </div>
    <div style="max-height: 70vh; overflow-y: auto">
      <table>
        <th>Nome</th>
        <th>Cognome</th>
        <th>Email</th>
        <th>Cellulare</th>

        <a
          *ngFor="let b of coaches"
          (click)="$event.stopPropagation(); rowClick(b)"
          [routerLink]="['/coach-detail', b.doc_ref]"
          class="link-no-style"
          style="display: table-row"
        >
          <td class="text-center">{{ b.name }}</td>
          <td class="text-center">{{ b.surname }}</td>
          <td class="text-center">{{ b.email }}</td>

          <td class="text-center">
            {{ b.phone
            }}<i
              class="ms-2 bi bi-clipboard"
              (click)="
                $event.stopImmediatePropagation();
                $event.preventDefault();
                copyToClipboard(b.phone)
              "
            ></i>
          </td>
        </a>
        <tr *ngIf="coaches.length === 0">
          <td colspan="7" style="text-align: center">
            Non sono stati trovati allenatori che soddisfano i criteri di
            ricerca.
          </td>
        </tr>
      </table>
    </div>

    <div class="table-footer">
      <div></div>
      <div class="elements-limit-container">
        <label for="elements-number">Righe per pagina</label>
        <select id="elements-number" [formControl]="elementsPerPage">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
        </select>
      </div>
    </div>
  </div>
</div>

<!--Alert section-->
<app-alert
  *ngIf="showAlert"
  (save)="onAlertConfimation($event)"
  [data]="{ type: undefined }"
  [title]="'Attenzione!'"
  [message]="'Vuoi davvero eliminare questo profilo allenatore?'"
>
</app-alert>
